<template>
  <div class="signupbgclr">
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important;" transition="slide-x-reverse-transition"
      v-model="snackbar" timeout="3000" :value="true" :color="snackbarclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>

    </v-snackbar>
    <v-container fill-height class="SsoView">
      <v-card max-width="400px" class="mx-auto my-auto py-8 pb-1 rounded-xl text-center cards">
        <div class="px-4 px-sm-6 px-md-8">
          <img src="@/assets/BD.svg" width="70%">
          <!-- <p class="headline font-weight-black">Branch Dashboard</p> -->

          <v-card-subtitle class="body-1">
            <!-- Track all of your data from anywhere, at any time. -->
          </v-card-subtitle>
          <!-- <img src="@/assets/Group 277.svg" class="mt-2 mb-6" width="100%"> -->


          <p class="title pb-6">Sign in your account using with Google</p>

          <!-- <v-btn @click="signin()" plain :ripple="false" block large color="white" class="btn mb-2 rounded-lg">
              <b style="color:black;">
                sign in with ZEBULL
              </b>
            </v-btn> -->
          <v-btn v-if="emailids == null" @click="googleSignIn()" block large class="btn white rounded-lg"><img
              class="pa-2" src="@/assets/google.svg" /><span class="text-none"><b>Sign in with Google</b></span></v-btn>

          <v-btn v-else @click="exciTing()" block large class="btn white rounded-lg">
            <img class="pa-2" src="@/assets/google.svg" /><span class="text-none"><b>Sign in as {{ dspname
            }}</b> <br> <span class="activemailsty caption">{{ emailids }} <v-icon class="activhovsty"
                  @click="removeData" size="16">mdi-close</v-icon></span></span></v-btn>


          <!-- <v-btn to="/signinwithotp" plain :ripple="false" block large color="white" class="btn mb-2 rounded-lg">
              <b style="color:black;">
                sign in with ZEBULL
              </b>
            </v-btn> -->

          <!-- <v-row no-gutters class="my-4">
            <v-col cols="5">
              <v-divider class="mx-2 mt-2" color="#DBE3EA"></v-divider>
            </v-col>
            <v-col cols="2">
              <p class="text-center caption mb-0"> or </p>
            </v-col>
            <v-col cols="5">
              <v-divider class="mx-2 mt-2" color="#DBE3EA"></v-divider>
            </v-col>
          </v-row>

          <v-btn @click="googleSignIn()" block large class="btn white rounded-lg"><span><b>Sign in with another account</b></span></v-btn> -->

          <v-card-subtitle style="font-size:11px;" class="text-center mb-3">
            <p style="color: #858b95" class="mt-8">
              By continuing with ZEBU, you agree our Terms and<br>
              Privacy Policy.
            </p>
          </v-card-subtitle>
        </div>
      </v-card>
      <v-dialog persistent v-model="branchdialog" class="elevation-0" max-width="400px">
        <v-card style="overflow: hidden;" class="elevation-0 rounded-lg">
          <v-row class="pl-4 pr-2 py-2">
            <v-col cols="10">
              <v-list-item-title class="font-weight-bold pb-4">Enter your Branch code</v-list-item-title>
            </v-col>
            <v-col cols="2" class="text-right pt-2">
              <v-btn tile icon @click="closeDialog()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17" fill="currentColor">
                  <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                  <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                </svg>
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-divider></v-divider> -->
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="suBmit()">
            <div class="px-4">
              <v-text-field color="#3B82F6" label="Email" disabled v-model="email" dense outlined></v-text-field>
              <v-text-field color="#3B82F6" label="Branch code" required oninput="this.value = this.value.toUpperCase()"
                ref="uid" :rules="[v => !!v || 'Branch code is required']" v-model="brcode" dense outlined></v-text-field>
              <!-- <v-text-field color="#3B82F6" label="Phone No" required type="number"
                :rules="[v => !!v || 'Phone number is required',(v) => /^[6-9][0-9]{9}$/.test(v) || 'Phone number must be 10 digit number']" v-model="mobile" dense outlined></v-text-field> -->
            </div>
            <v-row no-glutters class="px-4 pb-4">
              <v-col>
                <v-btn @click="closeDialog()" color="#ECEFF1" class="btnout mb-1 rounded-md elevation-0" block>
                  <span class="font-weight-bold black--text text-capitalize">
                    cancel
                  </span>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn type="submit" :disabled="subbtn" :loading="subbtn" color="#3B82F6"
                  class="btnout mb-1 rounded-md elevation-0" block>
                  <span class="font-weight-bold white--text text-capitalize">Submit</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { apiurl } from "../apiUrl.js";
import axios from "axios";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

export default {
  data() {
    return {
      snackbar: false,
      snackbarclr: "default",
      snackmsgbar: "",

      valid: true,
      brcode: null,
      mobile: null,
      email: null,
      emailids: null,
      branchdialog: false,
      dspname: null,
      subbtn: false,
    };
  },

  created() {
    //  temp login
    // let url = window.location.search;

    // if (url.slice(0, 4) == '?br=') {
    //   let val = (url.split("=")[1]).toUpperCase();
    //   localStorage.setItem("brcode", val)
    //   this.$router.push("/dashboard");
    // }
    // 
    this.emailids = localStorage.getItem("email");
    this.dspname = localStorage.getItem("name");

    if (this.emailids != null) {
      // this.$router.push("/dashboard");
    } else {
      localStorage.clear();
    }
    this.subbtn = false;
  },

  methods: {

    googleSignIn: function () {
      const provider = new GoogleAuthProvider();
      provider.addScope("profile");
      provider.addScope("email");

      provider.setCustomParameters({
        prompt: "select_account",
      });
      signInWithPopup(getAuth(), provider)
        .then((result) => {
          // console.log("Logged In", result);
          localStorage.clear();
          if (result.user) {
            localStorage.setItem("name", result.user.displayName);
            localStorage.setItem("email", result.user.email);
            this.email = result.user.email;
            this.branchdialog = true;
            setTimeout(() => this.$refs.uid.$refs.input.focus(), 100);
            this.subbtn = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    },
    closeDialog() {
      this.$refs.form.reset();
      this.branchdialog = false;
    },
    exciTing() {
      if (this.brcode != null) {
        this.$router.push("/dashboard");
      } else {
        this.email = this.emailids;
        this.branchdialog = true;
        setTimeout(() => this.$refs.uid.$refs.input.focus(), 100);
        this.subbtn = false;
      }
    },
    suBmit() {
      if (this.$refs.form.validate() == true) {
        this.subbtn = true;
        // localStorage.setItem("brcode", this.brcode)
        // this.$router.push("/dashboard");
        let data = JSON.stringify({
          "BRANCH_CODE": this.brcode,
          "EMAIL_ID": this.email
          // "EMAIL_ID": "aravind@zebuetrade.com"
        });

        let config = {
          method: 'post',
          url: `${apiurl}/user_checking`,
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        };
        let axiosThis = this;
        axios.request(config)
          .then((response) => {
            if (response.data.msg == "branch code and email id matched") {
              localStorage.setItem("brcode", this.brcode)
              localStorage.setItem("mode", response.data.user)

              axiosThis.$router.push("/dashboard");
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = response.data.msg;
            }
            axiosThis.closeDialog();
            axiosThis.subbtn = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    removeData() {
      localStorage.clear();
      window.location.reload();
    }
  },
};
</script>

<style>
/* ::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
} */

.btn {
  box-shadow: 0px 8px 16px 2px rgba(22, 34, 51, 0.08) !important;
}

.signupbgclr {
  background-color: #EFF6FF !important;
  background-image: url('../assets/ssobg.svg') !important;
  background-size: 100% !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 100vh !important;
  overflow-y: hidden !important;
}

.SsoView {
  height: 100vh !important;
  overflow-y: scroll !important;
}

.activhovsty {
  display: none !important;
}

.activemailsty:hover .activhovsty {
  display: inline !important;
}

.cards {
  /* height: 80%; */
  /* background-image: linear-gradient(to right top, #3b82f6, #4086f8, #468afb, #4b8ffd, #5093ff) !important; */
  box-shadow: 4px 4px 5px 0px rgba(255, 255, 255, 0.25) inset !important;
  background: #ffffffce !important;
  /* box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2) !important; */
  backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
}

@media only screen and (max-width: 959px) {
  .cards {
    height: 100%;
    background-image: none !important;
    background-color: #ffffff !important;
    box-shadow: none !important;
  }

  .signupbgclr {
    background-image: none !important;
    background-color: #ffffff !important;

  }

  .btn:hover {
    background-color: #ECEEF0 !important;
  }
}
</style>